export default __webpack_public_path__ + "static/media/bp10.d59aba5c.png";